<template>
  <div class="search-nav-start-end">
    <span class="start-end-title mr-4">{{label}}</span>
    <span class="mr-2"><date-selector v-model="sDate" style="width:130px;" @change="onChangeData"/></span>
    <span class="mr-2"><date-selector v-model="eDate" style="width:130px;" @change="onChangeData"/></span>
  </div>
</template>

<script>
import SearchNavItemSelect from '@/views/components/nav/SearchNavItemSelect'
import DateSelector from '@/views/components/DateSelector'
export default {
  name: 'SearchNavStartEnd',
  components: {
    DateSelector,
    SearchNavItemSelect},
  props:{
    label: {
      default: '대상기간',
      type: String
    },
    value: Object
  },
  computed: {
  },
  data () {
    return {
      sDate: '',
      eDate: ''
    }
  },
  mounted () {
    if (!this.value || !this.value.sDate) {
      this.$emit('input', {sDate: this.sDate, eDate:this.eDate})
    }
  },
  methods: {
    onChangeData () {
      this.$emit('input', {sDate: this.sDate, eDate:this.eDate})
      this.$emit('change', {sDate: this.sDate, eDate:this.eDate})
    }
  }
}
</script>

<style lang="scss" scoped>
.search-nav-start-end {
  display: flex;

  .start-end-title { white-space: nowrap;}

  & > span {
    display: flex;
    align-items: center;
    justify-content: center;
  }


}
</style>
